import { Web3ContractEntity } from 'shared/interfaces/analyze.interfaces';

export const LABEL_BY_TYPE = {
  [Web3ContractEntity.type.ERC1155]: 'ERC-1155 Token',
  [Web3ContractEntity.type.ERC20]: 'ERC-20 Token',
  [Web3ContractEntity.type.ERC721]: 'ERC-721 Token',
  [Web3ContractEntity.type.ERC404]: 'ERC-404 Token',
  [Web3ContractEntity.type.ERC20_CUSTOM]: 'ERC-20 Token',
  [Web3ContractEntity.type.ERC721_CUSTOM]: 'ERC-721 Token',
  [Web3ContractEntity.type.ERC1155_CUSTOM]: 'ERC-1155 Token',
};

export const getLabelByContractType = (type?: Web3ContractEntity.type): string => {
  const DEFAULT_LABEL = LABEL_BY_TYPE[Web3ContractEntity.type.ERC20];
  if (type === undefined || type === null) return DEFAULT_LABEL;
  return LABEL_BY_TYPE[type] || DEFAULT_LABEL;
};
